import { makeStyles } from 'tss-react/mui'
import { Property } from 'csstype'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  companyDetailsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '24px',
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
  radioButton: {
    '& .MuiFormGroup-root': {
      flexDirection: 'column !important' as Property.FlexDirection,
      gap: theme.spacing(1.25),
    },
  },
  radioButtonRow: {
    width: '100%',
    '& .MuiFormGroup-root': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      columnGap: theme.spacing(5),
      rowGap: theme.spacing(1.5),
    },
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      marginRight: 0,
      width: 'auto',
      maxWidth: 'fit-content',
    },
  },
  textField: {
    marginTop: theme.spacing(2.5),
  },
  endDateColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  estimatedDuration: {
    padding: 0,
    maxWidth: '100%',
  },
  dateHelperText: {
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.caption.fontWeight,
    lineHeight: theme.typography.caption.lineHeight,
    letterSpacing: theme.typography.caption.letterSpacing,
    color: theme.palette.labraText.description,
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1.75),
  },
}))
